module.exports = __webpack_public_path__ + "img/hsia-grid.775e228a.webp";